interface SkeletonProps {
  width?: string
  height?: string
  borderRadius?: string
  style?: React.CSSProperties
}

export function Skeleton({ width = '100%', height = '1em', borderRadius = 'var(--gl-radius)', style }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'block',
        width,
        height,
        borderRadius,
        background: 'linear-gradient(90deg, var(--gl-line) 25%, rgba(236,239,243,.4) 50%, var(--gl-line) 75%)',
        backgroundSize: '200% 100%',
        animation: 'glSkeleton 1.4s ease-in-out infinite',
        flexShrink: 0,
        ...style,
      }}
    />
  )
}

export function CardSkeleton({ lines = 3 }: { lines?: number }) {
  return (
    <div className="gl-card" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <Skeleton height="20px" width="55%" />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} height="14px" width={i === lines - 1 ? '70%' : '100%'} />
      ))}
    </div>
  )
}
